<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (form) {
  @if (isProtectPositionMode) {
    <form action="">
      <div class="protect-position-mode-title">
        {{ 'mydepot.trading.protect-order.position-header' | transloco }}
        <a
          href="https://support.finanzen-zero.net/hc/de/articles/4416405464977-Wie-funktioniert-die-Stop-Loss-Order-"
          target="_blank"
          rel="noopener nofererrer"
          class="link-secondary"
          >{{ 'mydepot.trading.protect-order.info-link' | transloco }}</a
        >.
      </div>

      <div class="row mb-3 px-3">
        <div class="col-lg-6">
          <div class="row">
            <div class="col-sm-4 pr-sm-4 pr-0 pl-0 pt-5">
              <div class="input-group-material select-dropdown keepcolor protect-position-mode">
                <ng-container *ngTemplateOutlet="selectDistance" />
              </div>
            </div>
            <div class="col-sm-4 pr-sm-4 pr-0 pl-0 pt-5">
              <div class="input-group-material keepcolor protect-position-mode">
                <ng-container *ngTemplateOutlet="inputStop" />
              </div>
            </div>
            <div class="col-sm-4 pr-lg-4 pr-0 pl-0 pt-5">
              <div class="input-group-material keepcolor protect-position-mode">
                <ng-container *ngTemplateOutlet="inputValidity" />
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 d-flex flex-row-reverse pt-lg-5 pt-4 pr-0">
          <div class="row">
            <div class="col-auto d-flex align-items-center pr-3 pl-0">
              <div>
                <a class="link-secondary text-default text-uppercase cursor-pointer" (click)="cancelProtectPositionMode.emit()">
                  {{ 'mydepot.trading.protect-order.cancel' | transloco }}
                </a>
              </div>
            </div>
            <div class="col-auto pl-sm-3 pl-0 pt-sm-0 pt-2">
              <web-design-system-button size="small" (click)="onSubmit()" [disabled]="!isValid">
                {{ 'mydepot.trading.protect-order.accept' | transloco }}
              </web-design-system-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  } @else {
    <hr />
    <form action="">
      <div class="row row--primary mb-5">
        <div class="col-12 text-center mt-2 mb-5">
          <h5 class="font-regular">
            {{ 'mydepot.trading.protect-order.header' | transloco: { name: asset.name, quantity: quantityAsNumber | toFixed: 0 : 'down' } }}
          </h5>
        </div>
        <div class="col-6 col-md-4">
          <div class="input-group-material select-dropdown keepcolor">
            <ng-container *ngTemplateOutlet="selectDistance" />
          </div>
        </div>
        <div class="col-6 col-md-4">
          <div class="input-group-material keepcolor">
            <ng-container *ngTemplateOutlet="inputStop" />
          </div>
        </div>
        <div class="col-12 col-md-4 mt-5 mt-md-0 mb-5">
          <div class="input-group-material keepcolor">
            <ng-container *ngTemplateOutlet="inputValidity" />
          </div>
        </div>
        @if (!isOrderExecuted) {
          <div class="col-12 mb-3 text-color-error">
            <div class="alert show alert-danger fade alert-dismissible">
              {{ 'mydepot.trading.protect-order.not-executed-error' | transloco }}
            </div>
          </div>
        }
        <div class="col-lg-4 d-flex justify-content-center justify-content-lg-end mb-3 mb-lg-0 align-items-center">
          <a class="link-secondary text-default text-uppercase" [routerLink]="commonRoutes.postlogin.member_home">{{
            'mydepot.trading.protect-order.to-depot' | transloco
          }}</a>
        </div>
        <div class="col-lg-8 text-center">
          <web-design-system-button type="secondary" size="small" (click)="onSubmit()" [disabled]="!isValid">
            {{ 'mydepot.trading.protect-order.accept' | transloco | uppercase }}
          </web-design-system-button>
        </div>
      </div>
    </form>
  }
} @else {
  <div class="row row--primary mt-4 mb-4">
    <div class="col-lg-6 mb-4 text-center">
      <web-design-system-button type="secondary" [fullwidth]="true" (click)="furtherOrder.emit()">
        {{ 'mydepot.trading.protect-order.additional-order' | transloco | uppercase }}
      </web-design-system-button>
    </div>
    <div class="col-lg-6 mb-4 text-center">
      <web-design-system-button type="secondary" [fullwidth]="true" [routerLink]="commonRoutes.postlogin.member_home">
        {{ 'mydepot.trading.protect-order.to-depot' | transloco | uppercase }}
      </web-design-system-button>
    </div>
  </div>
}

<ng-template #selectDistance>
  <select required name="distance" [ngModel]="form.distance" (ngModelChange)="onChangeDistance($event)" id="distance">
    @for (distance of distances; track $index) {
      <option [value]="distance" [selected]="distance === form.distance">
        {{ 'mydepot.trading.protect-order.distance.' + distance | transloco }}
      </option>
    }
  </select>
  <label for="distance">{{ 'mydepot.trading.protect-order.distance.label' | transloco }}</label>
</ng-template>

<ng-template #inputStop>
  <input required name="stop" type="number" id="stop" [ngModel]="form.stop" (ngModelChange)="onChangeStop($event)" />
  <label for="stop">{{ 'mydepot.trading.protect-order.stop' | transloco }}</label>
</ng-template>

<ng-template #inputValidity>
  <input
    required
    type="text"
    #validityInput
    id="validity"
    name="validity"
    ngbDatepicker
    #d="ngbDatepicker"
    placement="top-right"
    [ngModel]="form.validity"
    [minDate]="datePickerMin"
    [maxDate]="datePickerMax"
    [markDisabled]="markDisabledDates()"
    (focus)="openDatepicker($event, d, validityInput)"
    (ngModelChange)="onChangeValidity($event)"
  />
  <label for="validity">{{ 'mydepot.trading.protect-order.validity' | transloco }}</label>
</ng-template>
